import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-row nowrap justify-content-between heading" }
const _hoisted_2 = {
  key: 0,
  class: "mx-3 my-2"
}
const _hoisted_3 = { class: "" }

import { reactive, onMounted, onBeforeUnmount, ref } from "vue"

// Common components
import TextInput from "@/components/LoginRegister/common/inputs/Text/v1/Text.vue"
import FieldError from "@/components/LoginRegister/common/FieldError/v1/FieldError.vue"
import Button from "@/components/LoginRegister/common/Button/v1/Button.vue"
import Close from "@/components/LoginRegister/common/Close/v1/Close.vue"

// Composables
import useIsEmailValid from "@/composables/useIsEmailValid"
import useLoading, { isLoadingAny } from "@/composables/useLoading"

// libs
import scrollIntoView from "smooth-scroll-into-view-if-needed"
import { onKeyStroke } from "@vueuse/core"

// Svg
import CheckSvg from "@/components/LoginRegister/svg/CheckSvg.vue"

// Logic
import search from "@/logic/contact/search"

// state
import email from "@/state/email"

// Tracking 
import trackEmail from "@/tracking/trackEmail"

import { useI18n } from "vue-i18n"

interface Emits {
	(e: "emailExists", isEmailExists: boolean): void
}

// content

export default /*@__PURE__*/_defineComponent({
  __name: 'CheckForm',
  emits: ["emailExists"],
  setup(__props, { emit: __emit }) {

const {t} = useI18n()

// route




const content = window.content

// ref
const emailwrapper = ref()

// state
const state = reactive({
	showErrors: false,
})

// computed
const emailInputVal = ref("")
const isEmailValid = useIsEmailValid(emailInputVal)

// emit
const emit = __emit

// handlers

const handleEmailChange = (newVal: string) => {
	emailInputVal.value = newVal
}

const handleButtonClick = async () => {
	if (isLoadingAny.value) return

	if (!emailInputVal.value || !isEmailValid.value) {
		state.showErrors = true
		const emailElement = document.querySelector("#email") as HTMLInputElement
		await scrollIntoView(emailElement, {
			// scrollMode: 'if-needed',
			ease: (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
			duration: 750,
			block: "center",
			inline: "nearest",
		})
		return
	}
	state.showErrors = false
	const emailValue = emailInputVal.value.toLowerCase()
	email.value = emailValue

	const { startLoadingThis, stopLoadingThis } = useLoading()
	startLoadingThis()
	const isEmailExists = await search(emailValue)
	stopLoadingThis()

	emit("emailExists", isEmailExists)
	trackEmail(emailValue)

}

onMounted(() => {
	// onKeyStroke
	const stop = onKeyStroke("Enter", () => {
		if (!emailInputVal.value) return
		handleButtonClick()
	})
	onBeforeUnmount(() => stop())

	emailwrapper.value.querySelector("input").focus()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_unref(t)("loginRegister.log_in_or_register")), 1)
    ]),
    _createElementVNode("div", {
      ref_key: "emailwrapper",
      ref: emailwrapper,
      class: "my-3"
    }, [
      _createVNode(TextInput, {
        id: 'email',
        inputType: "email",
        value: emailInputVal.value,
        placeholder: _unref(t)('loginRegister.contacts_email'),
        "container-box-border": 
					state.showErrors && (!emailInputVal.value || !_unref(isEmailValid))
						? '1px solid var(--primary-orange)'
						: undefined
				,
        onInput: _cache[0] || (_cache[0] = (newVal) => handleEmailChange(newVal))
      }, {
        after: _withCtx(() => [
          (_unref(isEmailValid) && _unref(email))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(CheckSvg, {
                  height: 16,
                  width: 16,
                  color: 'var(--primary-green)'
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "placeholder", "container-box-border"]),
      (state.showErrors && (!emailInputVal.value || !_unref(isEmailValid)))
        ? (_openBlock(), _createBlock(FieldError, {
            key: 0,
            class: "my-1",
            ref: "email-error"
          }, {
            default: _withCtx(() => [
              (!emailInputVal.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("loginRegister.user_info_mandatory_field")), 1)
                  ], 64))
                : (!_unref(isEmailValid))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_unref(t)("loginRegister.email_not_valid")), 1)
                    ], 64))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          }, 512))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Button, {
        id: 'check-email-button',
        ref: "check-email-button",
        disabled: state.showErrors && (!emailInputVal.value || !_unref(isEmailValid)),
        onButtonClick: _cache[1] || (_cache[1] = () => handleButtonClick())
      }, {
        text: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_unref(t)("loginRegister.login_register")), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})